export const SET_QUANTITY = 'checkoutOptions/SET_QUANTITY';
